export const errorMessages = {
  REQUIRED: {
    message: 'This field is required.',
  },
  INVALID: {
    message: 'Please provide a valid value.',
  },
};
